module.exports = __webpack_public_path__ + "img/iranian-insurance.195b0ca.svg";